// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Dy","heading":"Ey","items":"Fy","featureCss":"Gy","disabled":"Hy","imgCss":"Iy"};